import React, { Fragment, useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router";
import {
  faPlus,
  faSave,
  faTimes } from
"@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import GetStudentService from "../../../../services/SchoolIT/GetStudentService";
import swal from "sweetalert";
import AppHeader from "../../../../Layout/AppHeader";
import AppSidebar from "../../../../Layout/AppSidebar";
import { Modal, ModalBody } from "reactstrap";
import Loader from "react-loader-spinner";
import "../../../admin/StudentProgress/StudentProgress.css";
import "../GoalCriteriaOrSetup.css";
import "./CreateGoalMap.css";

const goalFieldOptionArray = [
{ id: "course", field_name: "completed course requirement" },
{ id: "AND", field_name: "completed all of the following" },
{ id: "OR", field_name: "completed one of the following" }];

const asList = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.objects)) return payload.objects;
  if (Array.isArray(payload?.results)) return payload.results;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
};

const getRelatedGoalId = (item) => item?.id ?? item?.sub_goal ?? item?.goal?.id ?? null;
const getRelatedGoalName = (item) => {
  if (typeof item?.goal === "string") return item.goal;
  return item?.goal_name || item?.goal?.goal_name || "";
};

const createEmptyCriteria = (parentValue = false, parentCountArray = [], marginForParent = 0) => ({
  field_name: "",
  operator: "",
  value: "",
  course_req: "",
  green_simple_exp: "",
  parent: parentValue ? parentCountArray : [],
  level: parentValue ? parentCountArray.length : 0,
  margin: parentValue ? `${marginForParent}px` : "margin",
  have_not: ""
});


const AddNewModal = ({ isOpen, closeHandler, data }) => {
  const [input, setInput] = useState("");

  return (
    <Fragment>
      <Modal isOpen={isOpen} toggle={closeHandler} centered>
        <ModalBody>
          <h5 style={{ padding: "15px 16px 0 16px", textAlign: "center" }}>
            {data.title}
          </h5>
          <div style={{ position: "relative", padding: "10px" }}>
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              style={{ width: "100%", padding: "5px", borderRadius: "5px" }}
              type="text"
              placeholder="Field Name"
              className="require-input-name" />

          </div>
        </ModalBody>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "5px 0 30px 0"
          }}>

          <button
            disabled={!input}
            style={{ padding: "5px 20px", margin: "0 30px", fontSize: "20px" }}
            className={!input ? "admin-ccplus-btn primary is-disabled" : "admin-ccplus-btn primary"}
            onClick={() => data.save(input)}>

            <FontAwesomeIcon icon={faSave} style={{ margin: "0 10px" }} />
            Save
          </button>
          <button
            style={{
              padding: "5px 20px",
              margin: "0 30px",
              fontSize: "20px"
            }}
            className="admin-ccplus-btn ghost"
            onClick={closeHandler}>

            <FontAwesomeIcon icon={faTimes} style={{ margin: "0 6px" }} />
            Cancel
          </button>
        </div>
      </Modal>
    </Fragment>);

};

const CreateGoalMap = () => {
  let history = useHistory();
  let location = useLocation();
  const [parentCount, setParentCount] = useState(0);
  const [parentCountArray, setParentCountArray] = useState([]);
  const [courseCriteria, setCourseCriteria] = useState([createEmptyCriteria()]);
  const [goalFieldOption, setGoalFieldOption] = useState(goalFieldOptionArray);

  const [goalName, setGoalName] = useState();
  const [goalDescription, setGoalDescription] = useState();
  const [goalId] = useState(location?.pathname?.split("/").pop());
  const [goalData, setGoalData] = useState();
  const [addNewCourseModal, setAddNewCourseModal] = useState(false);
  const [addNewGoalModal, setAddNewGoalModal] = useState(false);
  const [marginForParent, setMarginForParent] = useState("");
  const [user] = useState(
    localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"))
  );
  const [requiredSubGoalData, setRequiredSubGoalData] = useState([]);
  const [selectedGoal, setSelectedGoal] = useState([]);

  const [goalpublishData, setGoalPublishData] = useState([]);
  const [courseListData, setCourseListData] = useState([]);
  const [fieldOperators, setFieldOperators] = useState([]);
  const [, setAddGoalName] = useState();
  const [criteriaError, setCriteriaError] = useState("");
  const [saving, setSaving] = useState(false);

  const gpaRef = useRef();
  const fieldOptionRef = useRef();
  const courseRef = useRef();
  const arithemeticOperatorRef = useRef();
  const timeout = useRef();
  const addGoalNameRef = useRef();

  const getGoalDetail = () => {
    GetStudentService.getGoalDetail(goalId)
    .then((data) => {
      setGoalData(data?.data);
      // let arr= Object.values(data?.data?.subgoal_id).map(item=>{ return {goal:item}})
      setSelectedGoal(Object.values(data?.data?.subgoal_id));
      if (data?.data?.green) {
        const green = Object.values(data.data.green).filter((item) => item && typeof item === "object");
        setCourseCriteria(green.length ? green : [createEmptyCriteria()]);
      }
      setGoalName(data?.data?.goal_name);
      setGoalDescription(data?.data?.goal_description);
    })
    .catch((_error) => {
    });
  };

  const isCriteriaComplete = (item) => {
    if (!item?.have_not || !item?.field_name) return false;
    if (item.field_name === "AND" || item.field_name === "OR") return true;
    if (item.field_name === "course") return !!item.course_req;
    return item.operator !== "" && item.operator != null && String(item.value ?? "").trim() !== "";
  };

  const saveGoalMap = () => {
    if (saving) return;
    const hasValidCriteria = (courseCriteria || []).some(isCriteriaComplete);
    if (!hasValidCriteria) {
      setCriteriaError("Criteria is required. Select a criteria option.");
      swal({
        text: "Empty criteria for selection. Please choose a criteria option.",
        icon: "warning",
        dangerMode: true,
        buttons: {
          cancel: true
        },
        closeOnClickOutside: false
      });
      return;
    }
    setCriteriaError("");
    if (goalId !== "create_goal") {
      for (let i = 0; i < courseCriteria.length; i++) {
        if (courseCriteria[i].simple_exp) {
          courseCriteria[i].green_simple_exp = courseCriteria[i].simple_exp;
          delete courseCriteria[i].simple_exp;
        } else
        courseCriteria[i].green_simple_exp = "";
      }
    }
    let obj = {
      goal_description: goalDescription,
      goal_id: undefined,
      goal_name: goalName,
      green: [null, ...courseCriteria],
      school_id: user?.school_id,
      subgoal_id: requiredSubGoalData
    };
    if (goalId !== "create_goal") {
      obj.goal_id = goalId;
      obj.subgoal_id = selectedGoal;
    }
    setSaving(true);
    GetStudentService.createGoalMap(obj)
    .then((data) => {
      if (data?.msg) {
        swal({
          text: `Selected Literal goalfield ${data["msg"]}`,
          icon: "warning",
          dangerMode: true,
          buttons: {
            cancel: true
          },
          closeOnClickOutside: false
        });
      } else {
        history.push("/school_it/ccplus");
      }
    })
    .catch((error) => {
      swal({
        text: error?.response?.data ?
        "The given Goal name already exists" :
        "Unable to save goal. Please try again.",
        icon: "warning",
        dangerMode: true,
        buttons: {
          cancel: true
        },
        closeOnClickOutside: false
      });
    })
    .finally(() => {
      setSaving(false);
    });
  };

  const saveNewCourse = (name) => {
    let obj = {
      name: name,
      school_id: user?.school_id
    };
    GetStudentService.saveNewCourse(obj)
    .then((_data) => {
      setAddNewCourseModal(false);
    })
    .catch((error) => {
      if (error.response.data) {
        swal({
          text: error.response.data.message,
          icon: "warning",
          dangerMode: true,
          buttons: {
            cancel: true
          },
          closeOnClickOutside: false
        });
      }
    });
  };
  const saveNewGoalField = (name) => {
    let obj = {
      field_name: name,
      school_id: user?.school_id
    };
    GetStudentService.saveNewGoalField(obj)
    .then((_data) => {
      setAddNewGoalModal(false);
    })
    .catch((error) => {
      if (error.response.data) {
        swal({
          text: error.response.data.message,
          icon: "warning",
          dangerMode: true,
          buttons: {
            cancel: true
          },
          closeOnClickOutside: false
        });
      }
    });
  };

  useEffect(() => {
    if (selectedGoal?.length > 0) {
      let array = [];
      selectedGoal.map((item) => {
        let obj = {};
        obj["sub_goal"] = getRelatedGoalId(item);
        obj["goal_name"] = getRelatedGoalName(item);
        obj["sub_goal_id"] = item?.sub_goal_id || item?.subgoal_id || item?.goal?.subgoal_id || "";
        array.push(obj);
      });
      setRequiredSubGoalData(array);
    } else {
      setRequiredSubGoalData([]);
    }
  }, [selectedGoal]);

  useEffect(() => {
    setParentCountArray([...parentCountArray, parentCount + 1]);
  }, [parentCount]);

  useEffect(() => {
    setMarginForParent(40 * parentCountArray.length);
  }, [JSON.stringify(parentCountArray)]);

  const AddNewCriteria = (parentValue) => {
    if (parentValue) {
      setParentCount(parentCount + 1);
    }
    setCourseCriteria([
      ...courseCriteria,
      createEmptyCriteria(parentValue, parentCountArray, marginForParent)
    ]);
  };

  const removeCourseCriteria = (index) => {
    if ((courseCriteria || []).length <= 1) return;
    const next = courseCriteria.filter((_, i) => i !== index);
    setCourseCriteria(next.length ? next : [createEmptyCriteria()]);
  };

  const getCourseList = () => {
    GetStudentService.listOfCourse(user?.school_id)
    .then((data) => {
      setCourseListData(asList(data?.data));
    })
    .catch((_error) => {
      setCourseListData([]);
    });
  };

  const getFieldOperators = () => {
    GetStudentService.listOfOperators()
    .then((data) => {
      setFieldOperators(asList(data?.data));
    })
    .catch((_error) => {
      setFieldOperators([]);
    });
  };

  const getGoalField = () => {
    GetStudentService.goalFieldForCreateGoal(user?.school_id)
    .then((data) => {
      const apiFields = asList(data?.data);
      const seen = new Set(goalFieldOptionArray.map((opt) => String(opt.id)));
      const extras = apiFields.filter((field) => field && !seen.has(String(field.id)));
      setGoalFieldOption([...extras, ...goalFieldOptionArray]);
    })
    .catch((_error) => {
      setGoalFieldOption(goalFieldOptionArray);
    });
  };

  const handleGoalNameChange = (e) => {
    const value = e?.target?.value ?? addGoalNameRef.current?.value ?? "";
    setAddGoalName(value);
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      getPublishData(value);
    }, 300);
  };

  const getPublishData = (goalName = "") => {
    GetStudentService.getGoalPublisher(user?.school_id, goalName)
    .then((data) => {
      setGoalPublishData(asList(data?.data));
    })
    .catch((_error) => {
      setGoalPublishData([]);
    });
  };

  const handlehaveOrHaveNotChange = (index, e) => {
    courseCriteria[index].have_not = e.target.value;
    setCourseCriteria([...courseCriteria]);
  };

  const handleFieldOption = (index, e) => {
    courseCriteria[index].field_name = e.target.value;
    setCourseCriteria([...courseCriteria]);
    if (e.target.value) setCriteriaError("");
  };

  const handleCourseChange = (index) => {
    courseCriteria[index].course_req = courseRef.current.value;
    setCourseCriteria([...courseCriteria]);
  };

  const handleArithemeticOperatorChange = (index) => {
    courseCriteria[index].operator = arithemeticOperatorRef.current.value;
    setCourseCriteria([...courseCriteria]);
  };

  const handleGPAChange = (index) => {
    courseCriteria[index].value = gpaRef.current.value;
    setCourseCriteria([...courseCriteria]);
  };

  const handleSelectedGoal = (item) => {
    const alreadyAdded = selectedGoal.some(
      (selected) => String(getRelatedGoalId(selected)) === String(getRelatedGoalId(item))
    );
    if (!alreadyAdded) {
      setSelectedGoal([
        ...selectedGoal,
        {
          id: getRelatedGoalId(item),
          goal_name: getRelatedGoalName(item),
          sub_goal: getRelatedGoalId(item),
          sub_goal_id: item?.subgoal_id || item?.sub_goal_id || ""
        }
      ]);
    }
    setGoalPublishData([]);
    if (addGoalNameRef.current) {
      addGoalNameRef.current.value = "";
    }
    setAddGoalName("");
  };

  const removeSelectedGoal = (index) => {
    selectedGoal.splice(index, 1);
    setSelectedGoal([...selectedGoal]);
  };

  useEffect(() => {
    if (goalId !== "create_goal") getGoalDetail();
    getCourseList();
    getFieldOperators();
    getGoalField();
    return () => clearTimeout(timeout.current);
  }, []);

  const relatedGoalOptions = (goalpublishData || []).filter(
    (item) =>
      !selectedGoal.some(
        (selected) =>
          String(getRelatedGoalId(selected)) === String(getRelatedGoalId(item))
      )
  );


  // setSubGoalData(subGoal);

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="admin-ccplus-page">
            <div className="admin-ccplus-header">
              <div>
                <h1 className="admin-ccplus-title">Create New Goal</h1>
                <p className="admin-ccplus-subtitle">
                  Define goal details and requirement structure
                </p>
              </div>
              <div className="admin-ccplus-header-actions">
                <button
                  type="button"
                  className="admin-ccplus-btn secondary toolbar"
                  onClick={() => setAddNewCourseModal(true)}>

                  Add New Required Course Set
                </button>
                <button
                  type="button"
                  onClick={() => setAddNewGoalModal(true)}
                  className="admin-ccplus-btn secondary toolbar">

                  Add New Goal Field
                </button>
                <button
                  type="button"
                  onClick={() => history.push("/school_it/ccplus")}
                  className="admin-ccplus-btn ghost toolbar">

                  Back
                </button>
              </div>
            </div>

            <div className="admin-ccplus-form-card admin-create-goal-form">
              <div className="admin-course-set-field">
                <label className="admin-course-set-label" htmlFor="goal-name">
                  Goal Name <span className="admin-course-set-required">*</span>
                </label>
                <input
                  id="goal-name"
                  value={goalName || ""}
                  onChange={(e) => setGoalName(e.target.value)}
                  type="text"
                  placeholder="Type a goal name"
                  className="admin-course-set-input" />

              </div>

              <div className="admin-course-set-field">
                <label className="admin-course-set-label" htmlFor="goal-description">
                  Goal Description{" "}
                  <span className="admin-course-set-required">*</span>
                </label>
                <textarea
                  id="goal-description"
                  value={goalDescription || ""}
                  onChange={(e) => setGoalDescription(e.target.value)}
                  className="admin-course-set-input admin-course-set-textarea"
                  placeholder="Type a goal description"
                  rows="5" />

              </div>

              <div className="admin-course-set-field admin-create-goal-subgoal">
                <label className="admin-course-set-label" htmlFor="add-goal-name">
                  Add Related Goal
                  <span className="admin-course-set-optional"> (optional)</span>
                </label>
                <div className="admin-create-goal-subgoal-wrap">
                  <input
                    id="add-goal-name"
                    ref={addGoalNameRef}
                    onChange={handleGoalNameChange}
                    onFocus={() => getPublishData(addGoalNameRef.current?.value || "")}
                    type="text"
                    className="admin-course-set-input"
                    placeholder="Type a goal name to add"
                    autoComplete="off" />

                  {relatedGoalOptions.length > 0 &&
                  <ul className="goal-dropdown-list">
                      {relatedGoalOptions.map((item, index) =>
                    <li
                      key={getRelatedGoalId(item) || index}
                      className="goal-dropdown-item"
                      onClick={() => handleSelectedGoal(item)}>

                          {getRelatedGoalName(item)}
                        </li>
                    )}
                    </ul>}

                  {selectedGoal?.length > 0 &&
                  <div className="admin-create-goal-chips">
                      {selectedGoal?.map((item, index) =>
                    <div
                      key={getRelatedGoalId(item) || index}
                      className="admin-create-goal-chip">

                          {getRelatedGoalName(item)}
                          <FontAwesomeIcon
                        onClick={() => removeSelectedGoal(index)}
                        icon={faTimes}
                        className="admin-create-goal-chip-remove" />

                        </div>
                    )}
                    </div>}

                </div>
              </div>

              <div className="admin-create-goal-criteria">
                <div className="admin-create-goal-criteria-header">
                  Create a set of criteria for green
                  <span className="admin-course-set-required"> *</span>
                </div>

                {courseCriteria?.length > 0 &&
                courseCriteria?.map((item, index) =>
                <div
                  key={`criteria-${index}`}
                  className="admin-create-goal-criteria-block">

                      <div
                    className="admin-create-goal-criteria-row"
                    style={{ marginLeft: item.level > 0 ? "48px" : "0" }}>

                        <button
                      type="button"
                      disabled={goalData?.is_global || courseCriteria.length <= 1}
                      onClick={() => removeCourseCriteria(index)}
                      className="admin-create-goal-remove-btn"
                      style={{
                        opacity: goalData?.is_global || courseCriteria.length <= 1 ? "0.65" : "1"
                      }}>

                          <FontAwesomeIcon icon={faTimes} />
                        </button>
                        <span className="admin-create-goal-criteria-label">
                          Student must
                        </span>
                        <select
                      value={item?.have_not || ""}
                      disabled={goalData?.is_global}
                      onChange={(e) => handlehaveOrHaveNotChange(index, e)}
                      className="admin-create-goal-select"
                      required>

                          <option value="" disabled>
                            Select Option
                          </option>
                          <option value="True">have</option>
                          <option value="False">have not </option>
                        </select>
                        <select
                      ref={fieldOptionRef}
                      value={item?.field_name || ""}
                      onChange={(e) => handleFieldOption(index, e)}
                      disabled={goalData?.is_global}
                      className={`admin-create-goal-select admin-create-goal-select--wide${criteriaError && !item?.field_name ? " is-invalid" : ""}`}
                      required
                      aria-required="true">

                          <option disabled value="">
                            Select
                          </option>
                          {(goalFieldOption?.length ? goalFieldOption : goalFieldOptionArray).map((fieldItem, fieldIndex) =>
                      <option
                        key={fieldItem?.id || fieldIndex}
                        value={fieldItem?.id}>

                              {fieldItem?.field_name || fieldItem?.name}
                            </option>
                      )}
                        </select>
                        {!(
                    item.field_name === "AND" ||
                    item.field_name === "OR" ||
                    item.field_name === "course" ||
                    item.field_name === "") &&

                    <div className="admin-create-goal-inline-group">
                            <select
                        value={item?.operator || ""}
                        disabled={goalData?.is_global}
                        ref={arithemeticOperatorRef}
                        onChange={() =>
                        handleArithemeticOperatorChange(index)}

                        className="admin-create-goal-select">

                              <option disabled value="">
                                Select Operator
                              </option>
                              {fieldOperators?.map((opItem, opIndex) =>
                        <option
                          key={opItem?.id || opIndex}
                          value={parseInt(opItem?.id)}>

                                  {opItem?.operator}
                                </option>
                        )}
                            </select>
                            <input
                        type="text"
                        ref={gpaRef}
                        value={item?.value || ""}
                        disabled={goalData?.is_global}
                        onChange={() => handleGPAChange(index)}
                        className="admin-create-goal-value-input" />

                          </div>}

                        {item.field_name === "course" &&
                    <select
                      ref={courseRef}
                      value={item?.course_req || ""}
                      disabled={goalData?.is_global}
                      onChange={() => handleCourseChange(index)}
                      className="admin-create-goal-select admin-create-goal-select--wide">

                            <option value="">Select Course</option>
                            {courseListData?.map((courseItem, courseIndex) =>
                      <option
                        key={courseItem?.course?.id || courseIndex}
                        value={courseItem?.course?.id}>

                                {courseItem?.course?.name}
                              </option>
                      )}
                          </select>}

                      </div>
                      {(item.field_name === "AND" ||
                  item.field_name === "OR") &&
                  <div className="admin-create-goal-subcriteria">
                          <button
                      type="button"
                      className="admin-ccplus-btn secondary toolbar"
                      onClick={() => AddNewCriteria(true)}>

                            <FontAwesomeIcon icon={faPlus} />
                          </button>
                          <p className="no-margin-bottom">
                            <b>Add additional sub-criteria</b>
                          </p>
                        </div>}

                    </div>
                )}

                {criteriaError &&
                <p className="create-goal-criteria-error">{criteriaError}</p>}

                <div className="admin-create-goal-add-criteria">
                  <button
                    type="button"
                    disabled={goalData?.is_global}
                    className={`admin-ccplus-btn secondary ${
                    goalData?.is_global ? "is-disabled" : ""
                    }`}
                    onClick={() => AddNewCriteria(false)}>

                    <FontAwesomeIcon icon={faPlus} />
                    Add additional Criteria
                  </button>
                </div>
              </div>

              <div className="admin-ccplus-form-actions">
                <button
                  type="button"
                  disabled={saving || !(goalName && goalDescription)}
                  className={`admin-ccplus-btn primary ${
                  !(goalName && goalDescription) ? "is-disabled" : ""
                  }`}
                  onClick={saveGoalMap}>

                  {saving ?
                <Loader type="TailSpin" color="#fff" height={16} width={16} /> :

                <FontAwesomeIcon icon={faSave} />}

                  {saving ? "Saving..." : "Save"}
                </button>
                <button
                  type="button"
                  className="admin-ccplus-btn ghost"
                  disabled={saving}
                  onClick={() => history.push("/school_it/ccplus")}>

                  <FontAwesomeIcon icon={faTimes} />
                  Cancel
                </button>
              </div>

              {addNewCourseModal &&
              <AddNewModal
                isOpen={addNewCourseModal}
                closeHandler={() => {
                  setAddNewCourseModal(false);
                }}
                data={{
                  title: "Create Required Course Set",
                  save: saveNewCourse
                }} />}



              {addNewGoalModal &&
              <AddNewModal
                isOpen={addNewGoalModal}
                closeHandler={() => {
                  setAddNewGoalModal(false);
                }}
                data={{ title: "New Goal Field", save: saveNewGoalField }} />}


            </div>
          </div>
        </div>
      </div>
    </Fragment>);

};

export default CreateGoalMap;